import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const FundingEnquiryUserEntityRecord = Record({
  companyName: '',
  id: 0,
});

export default class FundingEnquiryUserEntity extends FundingEnquiryUserEntityRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new FundingEnquiryUserEntity(hydrated);
  }
}
